import React from 'react';
import PropTypes from 'prop-types';
import { InputGroup, FormControl } from 'react-bootstrap';
import FormField from './FormField';
import QuickUpdatableComponent from './QuickUpdatableComponent';

class TextInput extends QuickUpdatableComponent {
    constructor(props) {
        super(props);
        this.ref = React.createRef();
        this.onChange = this.onChange.bind(this);
        this.onBlur = this.onBlur.bind(this);
    }

    onChange(evt) {
        if (this.props.onChange) {
            this.props.onChange(evt);
        }

        if (this.props.field.onChange) {
            this.props.field.onChange(evt);
        }

        if (this.props.onChanged) {
            this.props.onChanged(evt);
        }
    }

    onBlur(evt) {
        if (this.props.onBlur) {
            this.props.onBlur(evt);
        }

        if (this.props.field.onBlur) {
            this.props.field.onBlur(evt);
        }
    }

    render() {
        const {
            field,
            wrapInputField = undefined,
            plainInput,
            help,
            style,
            inputStyle,
            inputBeforeAddonStyle,
            label,
            loading,
            type,
            disabled,
            required,
            onFocus,
            onClick,
            beforeAddon,
            afterAddon,
            afterComponent,
            placeholder,
            onKeyPress
        } = this.props;

        const fieldProps = {...field};
        delete fieldProps['props'];

        let inputField = (
            <FormControl
                {...fieldProps}
                autoCapitalize="none"
                ref={this.ref}
                onChange={this.onChange}
                onBlur={this.onBlur}
                onFocus={onFocus}
                onClick={onClick}
                type={type || 'text'}
                className="form-control"
                disabled={disabled}
                id={field.name}
                style={inputStyle}
                placeholder={placeholder}
                onKeyPress={onKeyPress}
            />
        );

        if (wrapInputField) {
            inputField = wrapInputField(inputField, this.ref);
        }

        if (beforeAddon || afterAddon || afterComponent) {
            inputField = (
                <InputGroup>
                    {beforeAddon && (
                    <InputGroup.Addon style={inputBeforeAddonStyle}>
                        {beforeAddon}
                    </InputGroup.Addon>)}
                    {inputField}
                    {afterAddon && (
                    <InputGroup.Addon>
                        {afterAddon}
                    </InputGroup.Addon>)}
                    {afterComponent}
                </InputGroup>
            );
        }

        if (plainInput) {
            return inputField;
        }

        return (<FormField field={field} loading={loading} help={help} label={label} required={required} style={style}>
                    {inputField}
                </FormField>);
    }
};

TextInput.propTypes = {
    field: PropTypes.object.isRequired
};

export default TextInput;